export default "__VITE_ASSET__6KalvHx0__"